import React from "react";
import { Input, Icon } from "antd";

import styles from "./searchText.scss";

interface SearchTextProps {
  defaultValue: string;
  label: string | null;
  onPressEnter?: Function;
  onChange?: Function;
  placeholder: string;
  size: string;
}

const SearchText = (props: SearchTextProps) => {
  const { label } = props;
  return (
    <div className={styles.wrapper}>
      {label ? <span className="control-title">{label}</span> : null}
      <div className={styles.inputWrapper}>
        {/* 
        // @ts-ignore */}
        <Input {...props} className={styles.input} />
        <Icon className={styles.icon} type="search" />
      </div>
    </div>
  );
};

SearchText.defaultProps = {
  label: null
};

export default SearchText;



// WEBPACK FOOTER //
// ./src/components/SearchBar/controls/SearchText/index.tsx